import React from "react";
import clsx from "clsx";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import ReactSVGIcon from "@micado-digital/react-svg-icon/ReactSVGIcon";

import styles from "./Hamburger.styles";

const Hamburger = ({ lang, menuOpen, setMenuOpen }) => {
	const screenMD = useMediaQuery(theme => theme.breakpoints.up("md"));
	const css = styles();

	return (
		<button
			aria-label={
				menuOpen
					? lang === "de"
						? "Menü schließen"
						: "Close menu"
					: lang === "de"
					? "Menü öffnen"
					: "Open menu"
			}
			aria-controls={menuOpen ? "menu" : null}
			aria-expanded={menuOpen ? true : false}
			aria-haspopup
			className={clsx(css.hamburger, "mco-view-component-header-menu-mobilemenu__hamburger")}
			onClick={() => setMenuOpen(!menuOpen)}
		>
			{menuOpen && (
				<ReactSVGIcon
					color="primary"
					src={screenMD ? "/img/icons/close.svg" : "/img/icons/close-mobile.svg"}
					size={screenMD ? 40 : 24}
				/>
			)}
			{!menuOpen && (
				<ReactSVGIcon
					color="primary"
					src={screenMD ? "/img/icons/menu.svg" : "/img/icons/menu-mobile.svg"}
					size={screenMD ? 40 : 24}
				/>
			)}
		</button>
	);
};

export default Hamburger;
